import React, { FC } from 'react'

interface IToolDiagnosticsProps {}
const ToolDiagnostics: FC<IToolDiagnosticsProps> = () => {
  return <div className="p-3">Tool Diagnostics</div>
}

export default ToolDiagnostics
